<template>
    <div>
        <el-button type="primary" icon="el-icon-plus" @click="openAddDialog">添加</el-button>
        <el-dialog
                :visible="dialogVisible"
                title="添加海报"
                width="1000px"
                @close="closeDialog"
        >
            <el-form :model="posterDetail" ref="posterForm" class="poster-form" :rules="rules" label-width="200px">
                <el-form-item label="标题：" prop="title">
                    <el-input v-model="posterDetail.title"></el-input>
                </el-form-item>
                <el-form-item label="图片：" prop="posterUrl">
                    <upload v-model="posterDetail.posterUrl" :data="{type:'poster'}"></upload>
                </el-form-item>
                <el-form-item label="序号">
                    <el-input-number v-model="posterDetail.orderNum" :min="1" :max="10000000"
                                     label="序号"></el-input-number>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="handleSave('posterForm')">保存</el-button>
      </span>
        </el-dialog>
    </div>
</template>

<script>
    import {mapState, mapGetters, mapActions} from 'vuex';
    import Upload from 'components/upload';

    export default {
        name: 'CreatePoster',
        props: ['value'],
        data() {
            return {
                dialogVisible: false,
                posterDetail: {orderNum:1},
                rules: {
                    title: [{required: true, message: '标题不能为空！'}],
                    imageUrl: [{required: true, message: '图片不能为空！'}]
                }
            };
        },
        components: {
            Upload
        },
        computed: {
            ...mapState('posterSetting', [
                'query'
            ]),
            ...mapGetters('posterSetting', ['posterList'])
        },
        methods: {
            ...mapActions('posterSetting', ['create', 'list']),
            closeDialog() {
                this.dialogVisible = false;
                this.posterDetail = {};
                this.$refs['posterForm'].resetFields();
            },
            openAddDialog() {
                this.dialogVisible = true;
                this.posterDetail.orderNum = this.posterList.length + 1;
            },
            handleSave(formName) {
                this.$refs[formName].validate(valid => {
                    if (valid) {
                        this.create({...this.query, ...this.posterDetail}).then(() => {
                            this.$message({
                                message: '添加成功！',
                                type: 'success'
                            });
                            this.dialogVisible = false;
                            this.$emit('refresh');
                        });
                    }
                });
            }
        }
    };
</script>

<style lang="less" scoped>
    .poster-form {
        margin-right: 100px;
    }
</style>
